import { IAppState } from '../../redux';

export const selectMultipostingABGroup = (state: IAppState) => state.publishTerms.multipostingABGroup;
